import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useIdleTimer } from 'react-idle-timer';
export const withRouter = (WrappedComponent) => (props) => {
	const [state, setState] = useState('Active');
	const [count, setCount] = useState(0);
	const onIdle = () => {
		setState('Idle');
	};

	const onActive = () => {
		setState('Active');
	};

	const onAction = () => {
		setCount(count + 1);
	};

	const params = useParams();
	const navigate = useNavigate();
	const locations = useLocation();

	const [searchParams] = useSearchParams();
	const { getRemainingTime } = useIdleTimer({
		onIdle,
		onActive,
		onAction,
		timeout: 900000,
		throttle: 500,
		crossTab: true,
		leaderElection: true,
		syncTimers: 0,
	});
	return (
		<WrappedComponent
			{...props}
			locations={locations}
			params={params}
			navigate={navigate}
			searchParams={[...searchParams]}
			getRemainingTime={getRemainingTime()}
		/>
	);
};
